var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.521 7.942v-.006c-.11-2.23-.79-4.014-2.097-5.286C22.153 1.344 20.368.663 18.138.553h-.006C17.172.518 15.547.5 13.262.5c-2.286 0-3.91.018-4.87.053h-.006c-2.232.11-4.018.792-5.29 2.1-1.267 1.27-1.93 3.032-2.04 5.225C.984 8.882.949 10.53.949 12.812c0 2.271.035 3.899.106 4.87 0 .72.055 1.363.168 1.926l.003.015.004.016c.15.564.374 1.14.668 1.73.307.612.71 1.15 1.209 1.613 1.27 1.266 3.05 1.926 5.272 2.037.97.071 2.602.106 4.883.106 2.277 0 3.907-.035 4.878-.106 2.226-.075 4.011-.719 5.284-1.992 1.305-1.305 1.987-3.105 2.097-5.338v-.006c.036-.96.053-2.585.053-4.87 0-2.286-.017-3.911-.053-4.87z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.949,
    cy: 7.5,
    r: 1.5,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.949,
    cy: 13.5,
    r: 5,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2e88bb0a.svg";
export { ForwardRef as ReactComponent };